export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
export const TOGGLE_DRAWER_LEFT = 'TOGGLE_DRAWER_LEFT';
export const SHOW_NOTIFICATION = '[UTILS][NOTIFICATIONS][SHOW_NOTIFICATION] Show global notification';
export const REMOVE_NOTIFICATION = '[UTILS][NOTIFICATIONS][REMOVE_NOTIFICATION] Remove global notification';
export const ADD_TO_HISTORY = '[UTILS][HISTORY] add to history';
